module.exports = __webpack_public_path__ + "static/media/andrew-400x400.4360e99f.jpg";